import { Trans, useTranslation } from 'next-i18next';
import S from '../../views/manage/AssetControl.module.scss';
import Empty from '../service/common/Empty';
const ShowDesktop = () => {
  const {
    t
  } = useTranslation(['manage']);
  return <div className={S.empty_wrapper} data-sentry-component="ShowDesktop" data-sentry-source-file="ShowDesktop.tsx">
      <Empty image={{
      url: '/images/light/trouble/laptop_rabbit.png',
      width: 95,
      height: 87
    }} emptyItem={<Trans t={t} i18nKey={'manage:assetControl.show.desktop'} components={{
      S: <span className={S.primary_color_text} />
    }} />} useCustomMessage={true} data-sentry-element="Empty" data-sentry-source-file="ShowDesktop.tsx" />
    </div>;
};
export default ShowDesktop;